/* eslint-disable @typescript-eslint/naming-convention */

export interface DotNetFormulaDataModel {
	Name: string;
	Value: string;
}
